<template>
  <b-modal
    ref="validateCaseModal"
    :title="$t('diagnosis.btns.createAmendment')"
    centered
    modal-class="validated-case-modal"
  >
    <b-row class="px-3">
      <b-col class="text-center d-flex flex-column">
        <i
          class="fal fa-money-check-edit main py-2 fa-2x"
          aria-hidden="true"
        />
        <span class="mt-2">{{ $t('diagnosis.modals.caseIsValidated') }}</span>
        <span>
          <strong>{{ $t('diagnosis.modals.amendmentQuestion') }}</strong>
        </span>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row d-flex justify-content-between">
        <b-col cols="4">
          <b-button
            block
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </b-col>
        <!-- TODO: Darle funcionalidad al botón siguiente -->
        <b-col cols="4">
          <b-button
            block
            size="sm"
            class="btn--primary"
            @click="addAmendment"
          >
            {{ $t('diagnosis.btns.createAmendment') }}
          </b-button>
        </b-col>
      </div>
    </div>
  </b-modal>
</template>

<script>
import diagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'

export default {
    name: 'ModalValidatedCase',
    data() {
        return {
            casId: null
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        }
    },
    methods: {
        show(casId) {
            this.$refs.validateCaseModal.show()
            this.casId = casId
        },
        hide() {
            this.$refs.validateCaseModal.hide()
        },
        async addAmendment() {
            this.updateLoading(true)
            const [err] = await this.toCall(diagnosisCaseService.addAmendment(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.showSuccessModalGlobal(this.$t('diagnosis.amendmentAddedSuccessfully'))
            this.hide()
            this.$emit('amendmentAdded')
        }
    }
}
</script>

<style lang="scss">
    .validated-case-modal .modal-dialog {
        max-width: 20%;
    }
    @media (max-width: 1300px) {
        .validated-case-modal .modal-dialog {
            max-width: 33%;
        }
    }
    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .validated-case-modal .modal-dialog {
            max-width: 25%;
        }
    }
</style>
